import { Outlet } from "react-router";
import MediaBackground from "./background/MediaBackground";
import styles from "./viewport.module.css";
import { useContext, useEffect, useRef } from "react";
import ConsoleLogOverlay from "./overlays/ConsoleLogOverlay";
import { AppDebugSettings } from "../contexts/DebugSettingsContext";
import RadioVolumeOverlay from "./overlays/RadioVolumeOverlay";

export const Viewport = () => {
	const boxRef = useRef<HTMLDivElement>(null);
	const { showVolumeOverlay, showLoggingOverlay } = useContext(AppDebugSettings);

	useEffect(() => {
		const box = boxRef.current;
		if (!box) return;

		const resize = () => {
			const windowW = window.innerWidth;
			const windowH = window.innerHeight;
			const windowRatio = windowW / windowH;
			const targetRatio = 16 / 9;

			const width = windowRatio > targetRatio ? windowH * targetRatio : windowW;
			const height = windowRatio > targetRatio ? windowH : windowW / targetRatio;

			box.style.width = `${width}px`;
			box.style.height = `${height}px`;
		};

		window.addEventListener("resize", resize);
		resize();

		return () => window.removeEventListener("resize", resize);
	}, []);
	return (
		<main id="viewport" className={styles.viewport}>
			<div ref={boxRef} id="aspect-ratio-box" className={styles.aspectRatioBox}>
				<div
					id="video-container"
					className={styles.container}
					style={{ pointerEvents: "none", zIndex: 5 }}
				>
					<MediaBackground />
				</div>
				<div
					id="overlay-container"
					className={styles.container}
					style={{
						zIndex: 10,
						background: "rgba(0, 0, 0, 0.001)", // test: force rendering by adding transparent background
					}}
				>
					<Outlet />
					{showLoggingOverlay && <ConsoleLogOverlay />}
					{showVolumeOverlay && <RadioVolumeOverlay />}
				</div>
			</div>
		</main>
	);
};

export default Viewport;
